<template>
  <div class="offer" :class="size">
    <img :src="imageUrl" class="image">
    <div class="label">{{ name }}</div>
  </div>
</template>

<i18n>
  {
    "es": {
      "type": {
        "NGO": "ONG",
        "DISCOUNT": "Descuento",
        "SHAMPOO": "Shampoo",
        "PLASTIC_BOTTLE": "Botella de Plástico"
      }
    },
    "en": {
      "type": {
        "NGO": "NGO",
        "DISCOUNT": "Discount",
        "SHAMPOO": "Shampoo",
        "PLASTIC_BOTTLE": "Plastic Bottle"
      }
    }
  }
</i18n>

<script>
  export default {
    name: 'offer',
    props: {
      name: {
        type: String,
        required: true,
      },
      imageUrl: {
        type: String,
        required: true,
      },
      size: {
        type: String,
        default: 'small',
        validator: (size) => ['small', 'medium', 'large'].includes(size),
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/mixins.scss';

  .offer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .image {
    width: 5em;
    height: 5em;
    background-color: var(--color-background);
    object-fit: contain;
    border-radius: 1em;
    @include drop-shadow();
  }

  .label {
    text-align: center;
  }

  .small {
    & .image {
      width: 5em;
      height: 5em;
    }

    & .label {
      font-size: 0.75em;
    }
  }

  .medium {
    & .image {
      width: 6em;
      height: 6em;
    }

    & .label {
      font-size: 0.875em;
    }
  }

  .large {
    & .image {
      width: 10em;
      height: 7.5em;
      object-fit: cover;
    }

    & .label {
      font-size: 1em;
    }
  }
</style>
